import React from 'react';
import PropTypes from 'prop-types';
import Input from '@blaze-react/input';
import Select from '@blaze-react/select';
import { Checkbox } from '@blaze-react/checkboxes';
import { useTranslation } from '@blaze-cms/nextjs-components';
import { TRANSLATION_NAMESPACE } from '../../constants';

const FormInput = ({
  className,
  label,
  type,
  options,
  data,
  id,
  onChange,
  privacyPolicyUrl,
  termsAndConditionsUrl,
  isRequired,
  disabled
}) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACE);
  const { value, error, validationMessage } = data;
  const inputClassName = `${className}__input${error ? ' error' : ''}${
    type === 'select' ? ' select' : ''
  } ${id}`;

  const handleOnChange = ({ value: newValue }) => {
    onChange(id, newValue);
  };

  return (
    <div className={inputClassName}>
      {type === 'checkbox' && (
        <>
          <div className="checkbox-wrapper">
            <Checkbox
              checked={value}
              name={id}
              id={id}
              data-testid={id}
              onChange={handleOnChange}
            />
            <label>
              {t('TOS_LINE_1')}
              <a href={privacyPolicyUrl}> {t('PRIVACY_POLICY')}</a>. {t('TOS_LINE_2')}
              <a role="button" href={termsAndConditionsUrl}>
                {' '}
                {t('TERMS_AND_CONDITIONS')}
              </a>
              .
            </label>
          </div>
          {error && (
            <div className="validation" data-testid="validation-message">
              <i className="material-icons">warning</i>
              {t(validationMessage)}
            </div>
          )}
        </>
      )}
      {type === 'password' && (
        <Input
          label={label}
          onChange={handleOnChange}
          required={isRequired}
          value={value}
          type={type}
          error={error}
          validationMessage={t(validationMessage)}
        />
      )}
      {type === 'text' && (
        <Input
          label={label}
          onChange={handleOnChange}
          required={isRequired}
          value={value}
          type={type}
          error={error}
          validationMessage={t(validationMessage)}
        />
      )}
      {type === 'select' && (
        <Select
          label={label}
          selected={value}
          name={id}
          onChange={handleOnChange}
          options={options}
          selectDisabled={disabled}
          showDefaultOption={false}
          required
        />
      )}
    </div>
  );
};

FormInput.propTypes = {
  className: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  data: PropTypes.object,
  options: PropTypes.array,
  isRequired: PropTypes.bool,
  type: PropTypes.string,
  privacyPolicyUrl: PropTypes.string,
  termsAndConditionsUrl: PropTypes.string,
  disabled: PropTypes.bool
};

FormInput.defaultProps = {
  type: 'text',
  options: [],
  isRequired: false,
  privacyPolicyUrl: null,
  termsAndConditionsUrl: null,
  data: {},
  disabled: false
};

export default FormInput;
